import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["lastUpdateSummary"];

  async getLastUpdate(event) {
    event.preventDefault();
    console.error("Dude getLastUpdate has been called");

    const url = event.currentTarget.href;

    try {
      const response = await fetch(url, {
        headers: { "Accept": "application/json" }
      });

      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
      const data = await response.json();

      this.lastUpdateSummaryTarget.innerHTML = data.html;
    } catch (error) {
      console.error("Error loading auditor details:", error);
    }
  }
}
